DealController = window.DealController ?= {}

Discount = require '../../discount/frontend/views/discount'

DealController.init = (payload, done) ->
  $ ->
    new Discount.View
    done()



module.exports = DealController



// WEBPACK FOOTER //
// ./modules/deal/frontend/controller.coffee